export const rhsComponentType = {
  creatable: 'creatable',
  datePicker: 'datePicker',
  isolatedEditor: 'isolatedEditor',
  multiSelect: 'multiSelect',
  range: 'range',
} as const;

export type RHSComponentType = keyof typeof rhsComponentType;
